// releaseNote.ts
import type { ReleaseNote } from '../types/releaseNote';

export const CURRENT_RELEASE_NOTE: ReleaseNote = {
  type: 'web',
  version: '1.0.8',
  note: {
    ar: `🚀 شنو الجديد بلوحة التاجر

✅ إنشاء الطلب صار أسلس — إذا رجعت من خطوة اختيار شركة الشحن، تفاصيل طلبك (نوع الطلب، قابل للكسر، والمبلغ) تبقى مثل ما حددتها.

📦 حالات الطلب صارت أوضح — حالة "تمت المعالجة" تظهر كحالة مستقلة بدل "قيد المعالجة"، حتى تعرف بالضبط وين وصل طلبك.

🔎 فلتر جديد — هسه تقدر تفلتر قائمة طلباتك حسب حالة "تمت المعالجة" وتلگى هاي الطلبات بضغطة وحدة.

🔧 تحسينات عامة وإصلاح مشاكل لتجربة أسلس.

شكراً لاستخدامك بوكسي 💛`,
    en: `🚀 **What's New on Merchant Dashboard**

✅ Creating an order is smoother — if you go back from the carrier selection step, your order details (order type, fragile, and value) now stay exactly as you set them.

📦 Clearer order statuses — "Hold Resolved" now shows as its own status instead of "On Hold", so you always know where your order really stands.

🔎 New filter — you can now filter your orders list by "Hold Resolved" to find these orders in one click.

🔧 General improvements and fixes for a smoother experience.

Thanks for using Boxy 💛`,
  },
  created_at: '2026-06-04T12:00:00+00:00',
};
